import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ArrowNEIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M17.93 6.6a.9.9 0 0 0-.53-.52C17.25 6 17.1 6 17.02 6H6.98a1 1 0 0 0-.98.97 1 1 0 0 0 .97.98h7.58L6.3 16.27a1.04 1.04 0 0 0 0 1.43c.38.38 1.05.38 1.42 0l8.33-8.32v7.57a1 1 0 0 0 .97.98 1 1 0 0 0 .98-.98V6.98c0-.08 0-.23-.07-.38Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ArrowNEIcon;
